var getUniqueId = function getUniqueId() {
  return "".concat(Date.now()).concat(Math.floor(Math.random() * Math.floor(100)));
};

export default getUniqueId;